export const STORE_KEY = '$_libraries';


export const GET_USER_PROFILE = 'GET_USER_PROFILE';
export const GET_USER_PROFILE_EDIT = 'GET_USER_PROFILE_EDIT';
export const UPDATE_USER_PROFILE = 'UPDATE_USER_PROFILE';

export const GET_HOME_TIME_TABLE = 'GET_HOME_TIME_TABLE';
export const GET_USER_INFO = 'GET_USER_INFO';
export const GET_BASE_INFO = 'GET_BASE_INFO';
export const SET_PARAM_LIST_BOOKS = 'SET_PARAM_LIST_BOOKS';
export const MY_EBOOL_LIST = 'MY_EBOOL_LIST';
export const GET_LIST_CLASSES = 'GET_LIST_CLASSES';
export const GET_LIST_BOOK_TYPE = 'GET_LIST_BOOK_TYPE';
export const SET_PACTICE_ACTIVE = 'SET_PACTICE_ACTIVE';
export const SET_PARAM_ACTIVITY_LIST = 'SET_PARAM_ACTIVITY_LIST';
export const GET_ACTIVITY_LIST = 'GET_ACTIVITY_LIST';
export const GET_ALL_PROVICE = 'GET_ALL_PROVICE';
export const TYPE_ACTIVE_ACTIVITY = 1;
export const TYPE_REPLY_ACTIVITY = 2
export const TYPE_READ_BOOK_ACTIVITY = 3
export const TYPE_EXERCISE_ACTIVITY = 4
export const TYPE_EXERCISE_ACTIVITY_EXAM = 5
export const TYPE_EXERCISE_ACTIVITY_THEMATIC = 6
export const TYPE_EXERCISE_ACTIVITY_OTHER = 7
export const TYPE_EXERCISE_ACTIVITY_COMPLETET_THE_EXAM = 8
export const GET_LIST_TYPE_SCHOOL = "GET_LIST_TYPE_SCHOOL"
export const GET_TYPE_PRACTICE = "GET_TYPE_PRACTICE"
export const GET_BOOK_GROUP = "GET_BOOK_GROUP"
export const GET_SUBJECT = "GET_SUBJECT"
export const SET_PARAM_PRACTICE_CHART = "SET_PARAM_PRACTICE_CHART"
export const GET_PROCESS_PRACTICE_CHART = "GET_PROCESS_PRACTICE_CHART"
export const SET_PARAM_LEARNING_PROCESS = "SET_PARAM_LEARNING_PROCESS"
export const GET_LIST_PROCESS_LEARNING = "GET_LIST_PROCESS_LEARNING"
export const GET_OVER_SUBJECT_CHART = "GET_OVER_SUBJECT_CHART"
export const SET_PARAM_LIST_PROCESS_CHAT = "SET_PARAM_LIST_PROCESS_CHAT"
export const GET_LIST_PROCESS_CHAT = "GET_LIST_PROCESS_CHAT"
export const SET_DISPALY_DETAIL = "SET_DISPALY_DETAIL"
export const BY_YEAR = 3
export const SET_CHANG_CLASS = "SET_CHANG_CLASS"
export const ID_MODAL_CONFIRM_DEACTIVE_BOOK = "modal_confirm_deactive_book"
